'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var imagesPath = exports.imagesPath = function imagesPath(state, product_id) {
  return state.getIn(['products', 'images', product_id]);
};

var productsPath = exports.productsPath = function productsPath(state, feis_id) {
  return state.getIn(['feiseanna', 'products', feis_id]);
};


//////////////////
// WEBPACK FOOTER
// /Users/vidhigupta/isomorphic/lib/redux/actions/products/paths.js
// module id = 106
// module chunks = 0